import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Button from '../../../core/form/Button';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import LocaleSelect from '../../../core/form/LocaleSelect';
import LocalFileInputButton from '../../../core/form/LocalFileInputButton';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';

const EmailTemplateUploadForm = (props) => {
  const handleUploadClick = (locale, fileExists, callback) => {
    if (fileExists) {
      ConfirmationDialogService.show(
        'Update Email Template',
        `Would you like to change the template file from locale ${locale}?`,
        () => callback()
      );
    } else {
      callback();
    }
  };
  return (
    <>
      <span style={{ display: 'block', marginTop: '20px', fontWeight: 'bold' }}>Add Email Template to locale</span>
      <Row>
        <Column size={2}>
          <LocaleSelect
            key={props.selectedLocales.length}
            required
            onChange={(value) => props.onChange('locale', value)}
            value={get(props.values, 'locale', '')}
            errorText={get(props.errors, 'locale', null)}
            resultFilter={(locale) => !props.selectedLocales.find((selectedLocale) => selectedLocale === locale.key)}
          />
        </Column>
        <Column size={4}>
          <TextInput
            required
            label="Subject"
            onChange={(value) => props.onChange('subject', value)}
            value={get(props.values, 'subject')}
            errorText={get(props.errors, 'subject')}
          />
        </Column>
        <Column size={2}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LocalFileInputButton
              required={!get(props.values, 'id', false)}
              isFormItem
              formItemLabel="Upload html"
              label="Select a file"
              accept="html"
              value={get(props.values, 'template', null)}
              onClick={(callback) => {
                handleUploadClick(get(props.values, 'locale'), !!get(props.values, 'id'), callback);
              }}
              onChange={(value) => props.onChange('template', value, null)}
              errorText={get(props.errors, 'template', null)}
            />
            <div style={{ marginTop: '14px', marginLeft: '30px' }}>
              <Button
                label={get(props.values, 'id') ? 'Update' : 'Add Email Template to locale'}
                onClick={props.onSubmit}
              />
            </div>
          </div>
        </Column>
      </Row>
    </>
  );
};

EmailTemplateUploadForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
};

EmailTemplateUploadForm.defaultProps = {
  values: {},
  errors: {},
};

export default EmailTemplateUploadForm;
